import { checkUnreachable } from './errors.mjs';
"use strict";
const getImageOptimizerUrlByEnv = buildEnv => {
  switch (buildEnv) {
    case "proto":
      return "https://images.dev.svc.ui.com/";
    case "honeypot":
    case "qa":
      return "https://images.stg.svc.ui.com/";
    case "prod":
      return "https://images.svc.ui.com/";
    case "local":
    case "e2e":
    case void 0:
      return null;
    default:
      checkUnreachable(buildEnv);
      return null;
  }
};
const getOptimizedImageUrl = imageOptimizerUrl => ({
  src,
  width,
  quality = 75,
  format
}) => {
  if (!imageOptimizerUrl) {
    return src;
  }
  const srcUrl = new URL(src);
  if (srcUrl.pathname.endsWith(".svg")) {
    return src;
  }
  const url = new URL("/", imageOptimizerUrl);
  url.searchParams.set("u", src);
  url.searchParams.set("q", quality.toString());
  url.searchParams.set("w", width.toString());
  if (format) {
    url.searchParams.set("f", format);
  }
  return url.toString();
};
export { getImageOptimizerUrlByEnv, getOptimizedImageUrl };
//# sourceMappingURL=imageOptimizer.mjs.map
